import { emailRegex } from './constants';

export function isInvalidEmail(email) {
  if (email === undefined || email === '') {
    return false;
  }
  return !emailRegex.test(email);
}

export function isInvalidName(name) {
  return !name;
}

export function getValidationsObject(customer) {
  return {
    firstName: isInvalidName(customer.firstName),
    lastName: isInvalidName(customer.lastName),
    email: isInvalidEmail(customer.email),
  };
}

export function isInvalid(customer) {
  const validationsObject = getValidationsObject(customer);
  return validationsObject.firstName || validationsObject.lastName || validationsObject.email;
}

export function isValidCustomer(customer) {
  return !isInvalid(customer);
}

export function getErrorIndicationObject(currentState, customer) {
  // Error indication can be changed from truthy to falsy, but not vice versa in this case
  // It can only be changed from false to true upon submit attempt.
  const validationsObject = getValidationsObject(customer);

  return {
    firstName: currentState.firstName && validationsObject.firstName,
    lastName: currentState.lastName && validationsObject.lastName,
    email: currentState.email && validationsObject.email,
  };
}

export function setFocus({ firstNameRef, lastNameRef, emailRef, customer }) {
  const validationsObject = getValidationsObject(customer);

  if (validationsObject.firstName) {
    firstNameRef.current.focus();
  } else if (validationsObject.lastName) {
    lastNameRef.current.focus();
  } else if (validationsObject.email) {
    emailRef.current.focus();
  }
}

export function getFirstFieldWithError({ customer }) {
  const validationsObject = getValidationsObject(customer);

  if (validationsObject.firstName) {
    return 'firstName';
  } else if (validationsObject.lastName) {
    return 'lastName';
  } else if (validationsObject.email) {
    return 'email';
  } else {
    return '';
  }
}
